import { TIMEZONE_FORMAT } from "@/helpers/constants";
import { formatToClientTimezone } from "@/helpers/date";
import React, { useState, useEffect } from "react";

interface ClockProps {
  timeZone?: string;
}

const Clock: React.FC<ClockProps> = ({ timeZone }) => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    let interval: ReturnType<typeof setInterval> | null = null;

    const updateClock = () => {
      setCurrentTime(new Date());
    };

    const alignToNextMinute = () => {
      const now = new Date();
      const msUntilNextMinute =
        (60 - now.getSeconds()) * 1000 - now.getMilliseconds();
      return msUntilNextMinute;
    };

    const timeout = setTimeout(() => {
      updateClock();
      interval = setInterval(updateClock, 60000);
    }, alignToNextMinute());

    return () => {
      clearTimeout(timeout);
      if (interval) clearInterval(interval);
    };
  }, []);

  return (
    <div className="text-m font-semibold text-secondary-foreground">
      {formatToClientTimezone(currentTime, timeZone, TIMEZONE_FORMAT, "")}
    </div>
  );
};

export default Clock;
